import { RowEventDecodingAlgorithmDto } from "@/dtos";
import { EventDecodingAlgorithm } from "@/entities";

export const formatRowEventDecodingAlgorithm = (list: EventDecodingAlgorithm[]): RowEventDecodingAlgorithmDto[] => {
    return list.map(x => {
        const row: RowEventDecodingAlgorithmDto = {
            ...x,
            decoding_algorithm_label: x.decoding_algorithm.name,
            company_label: x.company.name,
            value: x.value,
            alert: (x.alert_active) ? "Si" : "No",
            notificate: (x.notificate_active) ? "Si" : "No",
        }

        return row;
    });
}